export default defineNuxtRouteMiddleware(() => {
  const { $store, $config } = useNuxtApp()

  if ($store.auth.isLoggedIn) {
    const { is_superuser, is_zuno_engineer, is_super_typewriter }
      = $store.auth.authenticatedUser

    if (!is_superuser) {
      const homeRoute = is_zuno_engineer || is_super_typewriter
        ? '/admin/home'
        : '/dashboard/home'

      return navigateTo(homeRoute)
    }
  }
  else {
    const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https'
    return (window.location.href = `${protocol}://${$config.public.fullyQualifiedDomain}`)
  }
})
